import { post, get, put } from '../httpmethods';
import { URL_API } from '../config';

export const userAPI = {
    
  authLogin: async (data) => {
    return await post(`${URL_API}/auth/login`, data);
  },

  getUsers: async (data) => {
    return await get(`${URL_API}/users`, data);
  },

  getUserById: async (id) => {
    return await get(`${URL_API}/users/${id}`);
  },
  createUser: async (data) => {
    return await post(`${URL_API}/users`, data);
  },
  updateUser: async (id, data) => {
    return await put(`${URL_API}/users/${id}`, data);
  },
  deleteUser: async (id) => {
    return await post(`${URL_API}/users/${id}`);
  },

}
